import { LogActionService } from '../../services/log-action/log-action.service'
import { ChangeDetectorRef } from '@angular/core'
import { Actor, Generator, Provider, Target } from '../../../../generated/graphql'
import { Observable } from 'rxjs'

export enum ChannelCommands {
  init = 'init',
  accepted = 'accepted',
  updateConfiguration = 'updateConfiguration',
  updateState = 'updateState',
  logAction = 'logAction',
  nextlabResources = 'nextlabResources',
  nextlabLogAction = 'nextlabLogAction',
  nextlabLogAccessor = 'nextlabLogAccessor',
}

export type json = any

export interface SbSChannelMessage {
  command: string
  message: json
}

export interface SbSChannelInitialisationData {
  language: string
  configuration: json
  state: json
  actor?: Actor
  generator?: Generator
  provider?: Provider | Observable<Provider>
}

export enum NextlabVerbs {
  // content-oriented verbs
  // indicate that the content/model of a tool has changed
  add = 'add',
  remove = 'remove',
  change = 'change',
  clear = 'clear',

  // process-oriented verbs
  // no change to the content/model of a tool has been made,
  // but still the user has made a meaningful action
  access = 'access',
  start = 'start',
  cancel = 'cancel',
  send = 'send',
  receive = 'receive',

  // storage-oriented verbs
  // the user has stored or retrieved something, or created a new resource from scratch
  new = 'new',
  open = 'open',
  create = 'create',
  update = 'update',
  delete = 'delete',

  // used to indicate the start of a tool, lab, ils, etc.
  // the object specifies 'what' has been started
  // - in the case of a tool or lab, the object should contain metadata.generator
  // - in the case of an ILS, the object should contain metadata.provider
  application_started = 'access',
  application_stopped = 'cancel',
  phase_changed = 'access',
}

export interface ActivityStreamObject {
  published: string
  actor: Actor
  verb: NextlabVerbs
  object: {
    objectType: string
    id?: string
    content?: any
  }
  target: Target
  generator: Generator
  provider: Provider
  appSequenceNumber: number
  sessionSequenceNumber?: number
  publishedServer?: string
}

export type NextlabChannelMessageLogAction = ActivityStreamObject

export class SbSMessageHandler {
  private port: MessagePort | undefined

  constructor(
    protected readonly logActionService: LogActionService,
    protected readonly changeDetectorRef: ChangeDetectorRef,
  ) {}

  setPort(port: MessagePort) {
    this.port = port
  }

  send(message: SbSChannelMessage) {
    this.port!.postMessage(message)
  }

  public handleMessage(channelMessage: SbSChannelMessage): void {
    console.log(`handle sbs channel message`, channelMessage)
    switch (channelMessage.command) {
      // case ChannelCommands.updateConfiguration:
      //   this.updateConfiguration(channelMessage.message)
      //   break
      default:
        console.warn(`unknown sbs channel message command`, channelMessage.command)
    }
  }
}
